import { ROUTES } from '../../routes';
import type { LinkResult, ResolvedTransactionModel } from './intents';

export function ok(href: string): LinkResult {
  return { status: 'ok', href };
}

export function unsupported(reason: string): LinkResult {
  return { status: 'unsupported', reason };
}

export function filterUrl(path: string, filterQuery: object): string {
  return `${path}?filterQuery=${encodeURIComponent(JSON.stringify(filterQuery))}`;
}

export function withSort(href: string, model: ResolvedTransactionModel, sort?: 'oldestFirst'): string {
  if (!sort) return href;
  const sortBy = model === 'legacy' ? 'txnTimestamp' : 'timestampMin';
  const params = `page=1&sortBy=${sortBy}&sortDir=asc`;
  return href.includes('?') ? `${href}&${params}` : `${href}?${params}`;
}

export function explorerPath(model: ResolvedTransactionModel): string {
  return model === 'legacy' ? ROUTES.allTransactions : ROUTES.allTransfers;
}
